<template>
  <div class="custom-polygon-container">
    <el-scrollbar class="custom-polygon-scrollbar">
      <div class="custom-polygon-entity"
        v-for="(entity, entityIndex) of dataList"
        :key="entityIndex"
        @click="customPolygonClick(entity)"
        :class="{
          'isHovered': entity[checkProp],
        }"
      >
        <div class="entity-title ellipsis">
          <svg-icon iconName="load-icon"
            v-if="entity[loadProp]"
          ></svg-icon>
          {{ entity['name'] }}
        </div>
        <div class="entity-control">
          <span title="修改" @click.stop="editFn(entity)">
            <svg-icon iconName="el-Edit"></svg-icon>
          </span>
          <span title="删除" @click.stop="deleteFn(entity)">
            <svg-icon iconName="el-Delete"></svg-icon>
          </span>
        </div>
      </div>
    </el-scrollbar>

    <EditCustomPolygon
      v-if="editCustomPolygonShowFlag"
      :target="editCustomPolygonTarget"
      :title="editCustomPolygonTitle"
      @close="editCustomPolygonShowFlagChange(false)"
      @submitCallback="dataInit"
    >
    </EditCustomPolygon>
    <ExportCustomPolygon
      v-if="exportCustomPolygonTarget"
      :target="exportCustomPolygonTarget"
      @close="exportCustomPolygonTargetClose"
    ></ExportCustomPolygon>
    <EditDraw 
      :layerList="dataList"
      ref="EditDrawRef"
      :bizType="2"
    />
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, toRaw,
  createApp,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import { ElMessageBox } from 'element-plus';
import ElementPlus from 'element-plus';
import store from '@/store';

import EditCustomPolygon from './components/EditCustomPolygon';
import ExportCustomPolygon from './components/ExportCustomPolygon';
import EditDraw from './components/EditDraw';

import {
  queryFavorites, queryFavoriteDetail,
} from '@/api/UserDrawApi';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

const deleteFn = (target)=>{
  ElMessageBox.confirm(
    '是否删除当前图层分组？',
    '删除图层分组',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(res=>{
    delFavorite(target['id']).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1);
        dataInit();
      }
    }).catch(err=>{
      console.log(err);
    });
  }).catch(err=>{
    console.log(err);
  });
}

const EditDrawRef = ref();

const polygonListProp = 'polygonList';
const customPolygonClear = (target, callback)=>{
  const layerRemoveFn = EditDrawRef.value && EditDrawRef.value['layerRemoveFn'];
  if(!target[polygonListProp] || !layerRemoveFn){
    return;
  }
  target[polygonListProp].forEach(layer =>{
    layerRemoveFn(layer);
  })
  callback();
}

const customPolygonInit = async (group, callback)=>{
  const dataChangePolygon = EditDrawRef.value && EditDrawRef.value['dataChangePolygon'];
  let polygonList;
  const data = await queryFavoriteDetail({
    bizType: 2,
    favoriteId: group['id'],
  });
  polygonList = dataChangePolygon(data.data.code == 1004?data.data.dataList:[], group);
  group[polygonListProp] = polygonList;
  callback();
}

const loadProp = 'loadFlag', checkProp = 'checked';
const customPolygonClick = (target)=>{
  const checkedChange = ()=>{
    target[checkProp] = !target[checkProp];
  }
  if(target[loadProp])return;
  target[loadProp] = true;
  if(target[checkProp]){
    customPolygonClear(target, ()=>{
      checkedChange();
      target[loadProp] = false;
    })
  }else{
    customPolygonInit(target, ()=>{
      checkedChange();
      target[loadProp] = false;
    });
  }
}

const editCustomPolygonTarget = ref(), editCustomPolygonTitle = ref(),
      editCustomPolygonclose = ()=>{
        editCustomPolygonTarget.value = undefined;
        editCustomPolygonTitle.value = undefined;
      },
      editCustomPolygonShowFlag = ref(false),
      editCustomPolygonShowFlagChange = (flag)=>{
        editCustomPolygonShowFlag.value = flag;
        if(!flag){
          editCustomPolygonclose();
        }
      }
const editFn = (target)=>{
  editCustomPolygonTitle.value = '修改图层分组';
  editCustomPolygonTarget.value = Object.assign({}, target);
  editCustomPolygonShowFlagChange(true);
}
const addCustomPolygonFn = ()=>{
  editCustomPolygonTitle.value = '新增图层分组';
  editCustomPolygonTarget.value = Object.assign({});
  editCustomPolygonShowFlagChange(true);
}
const exportCustomPolygonTarget = ref(undefined), exportCustomPolygonTargetClose = ()=>{
  exportCustomPolygonTarget.value = undefined;
}
const exportCustomPolygonFn = ()=>{
  exportCustomPolygonTarget.value = reactive({
    favoriteList: dataList.value,
  })
}

const dataList = ref([]), dataInit = ()=>{
  queryFavorites({}).then(res=>{
    if(res.data.code == 1004){
      dataList.value = res.data.dataList;
    }
  }).catch(err=>{
    console.log(err);
  });
}

defineExpose({
  addCustomPolygonFn,
  exportCustomPolygonFn,
})

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  dataInit();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
});

</script>

<style lang='less'>
.text-edit-container{
  width: auto !important;
  height: auto !important;
}
.leaflet-popup-edit-polygon{
  .leaflet-popup-content-wrapper{
    padding: 0;
    width: 600px;
    height: 600px;
    padding: 5px;
    .leaflet-popup-content{
      margin: 0;
      width: 100% !important;
      height: 100%;
      .leaflet-popup-edit-polygon-div{
        width: 100%;
        height: 100%;
        display: block;
        .el-overlay-dialog{
          overflow: hidden;
          .el-dialog{
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .el-dialog__body{
              flex: 1;
              min-height: 0;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang='less' scoped>
.custom-polygon-container{
  height: 100%;
  width: 100%;
  padding: 8px 5px;
  .custom-polygon-scrollbar{
    :deep(.el-scrollbar__view){
      display: flex;
      flex-direction: column;
      gap: var(--padDefaultSize);
      .custom-polygon-entity{
        // border: 2px solid var(--borderColor_10);
        border-radius: var(--borderRadiusSize);
        padding: var(--padDefaultSize);
        // background-color: var(--backgroundColor_21);
        backdrop-filter: blur(5px);
        cursor: pointer;
        &:hover{
          // border-color: var(--borderColor_6);
          background-color: var(--backgroundColor_21);
        }
        .entity-title{
          line-height: 24px;
          font-size: 16px;
          color: var(--fontColor_24);
        }
        .entity-control{
          text-align: right;
          span+span{
            margin-left: 5px;
          }
          .svg-icon{
            cursor: pointer;
            &:hover{
              fill: var(--iconColor_5);
              color: var(--iconColor_5);
            }
          }
        }
      }
      .isHovered{
        background-color: var(--backgroundColor_21);
      }
    }
  }
}
</style>